module.exports = __webpack_public_path__ + "img/3.d97094c6.png";